import styled from "styled-components";

export const Wrapper = styled.div`
    padding: calc(var(--bs-gutter) * 1.0) calc(var(--bs-gutter) * 1.5);
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    gap: 32px;

    h4.title {
        font-weight: 600;
    }

    div:first-child h4 {
        font-weight: 600;
    }

    .acct-details {
        padding: 16px;
    }

    .recent-transactions, .acct-details {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        > div {
            flex: 0 0 100%;
        }
    }

    .transaction-details, .acct-details {
        padding: 16px;
        border-radius: 12px;

    }

    .acct-details {
        display: flex;
        flex-direction: row;
        user-select: none;
        border-radius: 12px;

        svg {
            width: 1em;
            font-size: 40px;
            cursor: pointer;
        }

        > div {
            flex-basis: 33.333333%;
        }

        small {
            font-weight: 700;
            color: var(--color-border);
        }
        [data-theme="dark"] & small{
            --color-border: #F1ECFF73;
        }
        h6 {
            color: var(--color-text-light);
            font-weight: 600;
            font-size: var(--step--1);
        }

        h6.accn-icon {
            display: flex;
            align-items: center;
            justify-content: normal;
        }

        .first {
            display: flex;
            align-items: self-start;
            justify-content: space-between;

            > span {
                color: #00BD59;
            }
        }
    }

    ${({theme}: { theme: any }) => theme.breakpoints.down('lg')} {
        max-width: 100% !important;
    }

    ${({theme}: { theme: any }) => theme.breakpoints.up('md')} {
        padding: calc(var(--bs-gutter) * 1.0) calc(var(--bs-gutter) * 1.5);
    }


    ${({theme}: { theme: any }) => theme.breakpoints.down("md")} {
        h4.title {
            font-weight: 500;
        }

        max-width: 100% !important;
        padding: 1rem;
        margin-top: 4rem;

        div:first-child h4 {
            font-weight: 500;
        }

        .recent-transactions, .acct-details {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;

            small {
                color: black;
                font-weight: 400;
            }

            h6 {
                font-weight: 500;
            }

            > :not([hidden]) ~ :not([hidden]) {
                --tw-space-x-reverse: 0;
                margin-top: .5rem;

            }

            > div {
                flex: 0 0 100%;
                display: flex;
                justify-content: space-between;
            }
        }

        .recent-transactions .transaction-details {
            padding: 0;
            background: none;
        }
    }
`